import React from 'react';
import SuperadminEditFormContainer from './SuperadminEditFormContainer';

const SuperadminEditPage = () => (
  <div className="modal-wrap">
    <div className="container-fluid container-home">
      <div className="header">
        <div className="header-body">
          <div className="row">
            <div className="col-sm-12">
              <h1 className="header-title">Edit List</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <SuperadminEditFormContainer />
        </div>
      </div>
    </div>
  </div>
);

export default SuperadminEditPage;
